<!-- HEADER -->
<header id="main-header" class="py-2 bg-secondary text-white">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h1>
          <i class="fa fa-comments" aria-hidden="true"></i> Sessions</h1>
      </div>
    </div>
  </div>
</header>

<!-- SEARCH -->
<section id="search" class="py-4 mb-4 bg-light">
  <div class="container">
    <div class="row">
      <div class="col-md-6 ml-auto">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Search Sessions...">
          <div class="input-group-append">
            <button class="btn btn-secondary">Search</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SESSIONS -->
<!-- <section id="sessions">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-header text-center">
            <h4>All Sessions</h4>
          </div>
          <table class="table table-striped text-center">
            <thead class="thead-dark">
              <tr>
                <th>Topic</th>
                <th>Time</th>
                <th>Status</th>
                <th>Details</th>
                <th>Visit</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let session of sessionList">
                <td>{{ session.sessionTopic }}</td>
                <td>{{ session.startTime }}</td>
                <td *ngIf="session.status=='UPCOMING'" style="color: blue;">Upcoming</td>
                <td *ngIf="session.status=='LIVE'" style="color: green;"><i class="fa fa-circle" aria-hidden="true"></i> Live</td>
                <td *ngIf="session.status=='COMPLETE'">Complete</td>
                <td>
                  <a class="btn btn-secondary text-white" data-toggle="modal" data-target="#sessionDetailsModal" (click)="onDetailsClick(session._id)">
                    <i class="fas fa-angle-double-right"></i> Details
                  </a>
                </td>
                <td>
                  <a class="btn btn-secondary text-white" data-toggle="modal" data-target="#chatroomModal">
                    <i class="fa fa-comments"></i> Chatroom
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</section> -->

<div class="container">
  <div class="row" style="border: 1px solid silver; padding: 10px;">

    <div class="row mb-1">
      <div class="col-4">
        <div class="py-2 bg-dark text-white text-center">
          <b>All Sessions</b>
        </div>
      </div>
      <div class="col-8">
        <div class="py-2 bg-dark text-white text-center">
          <b>Chatroom</b>
        </div>
      </div>
    </div>

    <!-- CHAT-WINDOW -->
    <div class="row chat-window">
      <div class="col-4 session-list bg-light">

        <a style="cursor: pointer;" *ngFor="let session of sessionList" (click)="onSessionSelect(session._id, session.status)">
          <div class="card my-2">
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <h5 class="card-title">{{ session.sessionTopic }}</h5>
                  <h6 class="card-subtitle mb-2 text-muted">{{ session.startTime }}</h6>
                  <p class="card-text">{{ session.sessionCode }}</p>
                </div>
                <div class="col-4 text-center">
                  <b *ngIf="session.status=='UPCOMING'" style="color: blue;">Upcoming</b>
                  <b *ngIf="session.status=='LIVE'" style="color: green;"><i class="fa fa-circle" aria-hidden="true"></i> Live</b>
                  <b *ngIf="session.status=='COMPLETE'" style="text-align: right;">Complete</b>
                </div>
              </div>
            </div>
          </div>
        </a>

      </div>
      <div class="col-8 chatroom">
        <app-ecachatroom></app-ecachatroom>
      </div>
    </div>
  </div>
</div>


<!-- Session Details Modal -->
<div class="modal fade" id="sessionDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-secondary text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ selectedSession.sessionCode }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <b>Session Code :</b>
          </div>
          <div class="col-7">
            {{ selectedSession.sessionCode }}
          </div>
        </div>
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <b>Topic :</b>
          </div>
          <div class="col-7">
            {{ selectedSession.sessionTopic }}
          </div>
        </div>
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <b>Description :</b>
          </div>
          <div class="col-7">
            {{ selectedSession.sessionDescription }}
          </div>
        </div>
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <b>Start time :</b>
          </div>
          <div class="col-7">
            {{ selectedSession.startTime }}
          </div>
        </div>
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <b>End time :</b>
          </div>
          <div class="col-7">
            {{ selectedSession.endTime }}
          </div>
        </div>
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <b>Status :</b>
          </div>
          <div class="col-7">
            {{ selectedSession.status }}
          </div>
        </div>
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <b>Sub-admins :</b>
          </div>
          <div class="col-7">
            <p *ngFor="let subAdmin of subAdminArray">{{ subAdmin }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Chatroom Modal -->
<!-- <div class="modal fade" id="chatroomModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-secondary text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Chatroom</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-chatroom></app-chatroom>
      </div>
    </div>
  </div>
</div> -->
